import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGhlPlans, getSummaryPlan } from '../../../../../global/ducks/benadmin-api';
import { getOePlanOffering } from '../../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { InstitutionState } from '../institution-model';
import { dispatchSetPlanSummary, setGhlPlans, setOePlanOfferings } from '../institution-slice';

export function usePlanSummary(institutionClientNumber: string) {
	const dispatch = useDispatch();
	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);

	useEffect(() => {
		if (!institutionState?.planSummaryLoaded) {
			dispatch(getSummaryPlan(institutionClientNumber, dispatchSetPlanSummary(dispatch)));
		}
		if (!institutionState?.ghlPlanLoaded) {
			dispatch(getGhlPlans(institutionClientNumber, (res) => dispatch(setGhlPlans(res?.data)), () => dispatch(setGhlPlans(null))));
		}
		if (!institutionState?.oePlanOfferingLoaded) {
			dispatch(getOePlanOffering(institutionClientNumber, (res) => dispatch(setOePlanOfferings(res?.data))));

		}
	}, [institutionClientNumber]);


	return institutionState?.planSummaryLoaded && institutionClientNumber && institutionState?.ghlPlanLoaded && institutionState?.oePlanOfferingLoaded;
}
